/**
 * 股吧签
 */
import React, { useEffect } from "react"
import './index.less'

export function GuBa(props:{quotecode:string}) {

  useEffect(()=>{
    let url = '//quote.eastmoney.com/unify/codecenter/' + props.quotecode + '.js'
    $.ajax({
        url: url,
        type: 'get',
        dataType: 'jsonp',
        // jsonp:'callback',
        // jsonpCallback:'innerCodeByUnifyId',
        jsonpCallback:'codecenterget',
        success: function (data){
            let list = new window.PageList({
              "stockcode":String(data?.innerCode ? data.innerCode : ''),
                "root":"#gb-new",
                "isRelease":true
            });
            list.enter();
        },
        error:function(){

        }
    })
  },[])

  return (
      <>
        <div id="gb-new"></div>
      </>
  )
}